var map = {
	"./index.js": "./src/store/plugins/index.js",
	"./mqtt-bridge.js": "./src/store/plugins/mqtt-bridge.js",
	"./persist-state.js": "./src/store/plugins/persist-state.js",
	"./pipe-stock.js": "./src/store/plugins/pipe-stock.js",
	"./save-kchart-study-settings.js": "./src/store/plugins/save-kchart-study-settings.js",
	"./sync-multi-view-stocks.js": "./src/store/plugins/sync-multi-view-stocks.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/store/plugins sync \\.js$";